import ModelUtil from '@leverege/model-util';
import { FontModel } from '@leverege/ui-style-elements';
const TYPE = 'detail.DetailList';
function create(extend) {
  return {
    type: TYPE,
    variant: null,
    background: null,
    labelColor: null,
    labelVariant: null,
    valueColor: null,
    suffixColor: null,
    header: {
      controlsVisible: false,
      visible: false,
      primary: {
        attrName: 'name',
        color: null,
        font: FontModel.create()
      },
      // secondary : {
      //   attrName : 'id',
      //   color : null,
      //   font : FontModel.create(),
      // },
      icon: {
        attrName: 'icon',
        size: '24px'
      }
    },
    footer: {
      visible: false
    },
    details: [],
    ...extend
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('variant'),
  ...ModelUtil.createAllValue('background'),
  ...ModelUtil.createAllValue('icon'),
  ...ModelUtil.createAllValue('header/visible', 'HeaderVisible'),
  ...ModelUtil.createAllValue('header/controlsVisible', 'HeaderControlsVisible', undefined, {
    defaultValue: true
  }),
  ...ModelUtil.createAllValue('header/primary/attrName', 'HeaderNameAttribute'),
  ...ModelUtil.createAllValue('header/primary/color', 'HeaderNameColor'),
  // ...ModelUtil.createAllValue( 'header/primary/font', 'HeaderNameFont' ),
  ...ModelUtil.createAllValue('header/icon/attrName', 'HeaderIconAttribute'),
  ...ModelUtil.createAllValue('header/icon/size', 'HeaderIconSize'),
  ...ModelUtil.createAllValue('footer/visible', 'FooterVisible'),
  // ToDo : Add background and header options here
  ...ModelUtil.createAllValue('evenRowBackground'),
  ...ModelUtil.createAllValue('oddRowBackground'),
  ...ModelUtil.createAllValue('labelColor'),
  ...ModelUtil.createAllValue('labelVariant'),
  ...ModelUtil.createAllValue('valueColor'),
  ...ModelUtil.createAllValue('valueVariant'),
  ...ModelUtil.createAllValue('suffixColor'),
  ...ModelUtil.createAllArray('details', 'Detail', 'Details')
};